export type SearchParamsTypes = {
  [key: string]: string | string[] | undefined;
};

export type EmptyObjectType = {
  [K in string | number | symbol]: never;
};

/**
 * The types of buttons that can be rendered.
 * - primary: A primary button with a background color of secondary and white text.
 * - default: A default button with a background color of gray-50 and gray-900 text.
 * - disabled: A disabled button with a background color of gray-200 and gray-400 text.
 */
export enum ButtonTypesEnum {
  primary = "primary",
  default = "default",
  disabled = "disabled",
  secondary = "secondary",
  noStyle = "noStyle",
}

/**
 * Unit types for quantity measurements
 */
export enum UnitTypeEnum {
  pieces = "pieces",
  pallets = "pallets",
  containers = "containers",
}

/**
 * Availability types for product offerings
 */
export enum AvailabilityTypeEnum {
  ALWAYS_IN_STOCK = "ALWAYS_IN_STOCK",
  UPCOMING_STOCK = "UPCOMING_STOCK",
  IN_STOCK_NOW = "IN_STOCK_NOW",
}

/**
 * Price unit types
 */
export enum PriceUnitEnum {
  pieces = "pieces",
  wattpeak = "wattpeak",
}

/**
 * Product categories
 */
export enum ProductCategory {
  Inverters = "PV Inverters",
  Modules = "PV Modules",
  Batteries = "PV Batteries",
  Other = "Other",
}

/**
 * PQ (Product Quote) types
 */
export enum PQTypeEnum {
  Regular = "Regular",
  Evergreen = "Evergreen",
  Inventory = "Inventory",
}

export type TranslateType = (key: string, params?: Record<string, unknown>) => string;

export type AddressType = {
  city?: string | null;
  country?: string | null;
  country_code?: string | null;
  postal_code?: string | null;
  state?: string | null;
  state_code?: string | null;
  street?: string | null;
} | null;

export type WeekPickerModalProps = {
  value?: Date;
  firstAvailableDate?: Date;
  lastAvailableDate?: Date;
  onChange?: (value: Date) => void;
  submitAction?: () => void;
  isFormChanged?: boolean;
  modalHeaderTitle?: string;
  modalHeaderBody?: string;
  labelText?: string;
  confirmButtonText?: string;
  classNames?: string;
  showWarning?: boolean;
  uniqueQueryId?: string;
  isDisabled?: boolean;
  placeholder?: string;
};
